<template>
      <div no-body > 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><label>Filter</label></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblPjx"
          responsive
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="20"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(nomor)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template>
        <template v-slot:cell(compaddr1)="data">
          {{ data.item.compaddr1 }}
          {{ data.item.compaddr2 }}
          {{ data.item.compaddr3 }}
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="(data.item.compphone)">P.{{data.item.compphone}}</span>&nbsp;
          <span v-if="(data.item.compfax)">F.{{data.item.compfax}}</span>
        </template>

        </b-table>
      <b-row>
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>        
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols="4" label="Limit per page"  style="margin-top:0 !important;">
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import crud from "../../apis/crud";

export default {
  data() {
    return {
      fields: [
          {
            key: "pjxcode",
            label: "Project Code",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "pjxname",
            label: "Project Name",
            sortable: true
          },
          {
            key: "job_name",
            label: "Project Type",
            sortable: true
          },
          {
            key: "pjxdesc",
            label: "Description",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name",
            sortable: true
          },
          {
            key: "cust_po",
            label: "Customer Order#",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "isactive",
            label: "Active",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
      ],
      items:[],
      tblData: {
        tablename:'vwproject',
        page: 1,
        total: 0,
        limit:25,
        sortBy: 'pjxcode',
        sortDesc: false
      },
      filter:null
    };
  },
 props: ["isactive"],  
  created: async function() {
      this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    //   this.tblData.page = 1;
    // },
    data: async function(ctx) {
      if (this.isactive){
        this.tblData.customQuery = 'isactive=' + encodeURIComponent(this.isactive);
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.items=await crud.list(this.tblData);
      return this.items;      

    },
    selectItem(item,index) {
        this.$emit("click", item);
    },  
    refresh() {
      this.$refs.tblPjx.refresh();
    }
  }
};
</script>
